import { InjectionToken } from '@angular/core';
import { ILeathermanAppConfig } from '../app.config';

export const LeathermanAppConfigInjectionToken = new InjectionToken<
  ILeathermanAppConfig
>('LeathermanAppConfig');
